import { render, staticRenderFns } from "./Insta.vue?vue&type=template&id=6b2438be"
import script from "./Insta.vue?vue&type=script&lang=js"
export * from "./Insta.vue?vue&type=script&lang=js"
import style0 from "./Insta.vue?vue&type=style&index=0&id=6b2438be&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports